<div
  class="inline-flex shrink-0 select-none items-center justify-center rounded-full shadow-2xs font-medium uppercase leading-none tracking-tight {{
    colourClasses
  }} {{ fontSizeClass }} {{ avatarClasses }}"
  [style.--tw-dynamic-colour]="colourValue"
  [style.width.px]="size"
  [style.height.px]="size"
  [attr.aria-label]="name ? name + ' avatar' : 'User avatar'"
>
  @if (systemUser) {
    <ion-icon class="size-4" name="settings-outline"></ion-icon>
  } @else {
    {{ initials }}
  }
</div>
